export const PUBLIC_URL = process.env.PUBLIC_URL || "";

export const publicAsset = (path) => `${PUBLIC_URL}${path}`;
